import { truckBrandsApi } from "./truckBrands.api";

export const { useGetTruckBrandQuery, useGetTruckBrandsQuery, useSaveTruckBrandMutation, useDeleteTruckBrandMutation } = truckBrandsApi;
